export const issuesConstants = {
    ISSUES_GETALL: 'issues/getall',
    ISSUES_OWNER: 'issues/owner',
    ISSUES_CLEAR: 'issues/clear',
    ISSUES_UPDATE: 'issues/update',
    ISSUES_INSERT: 'issues/insert',
    ISSUES_EXTERNAL: 'issues/external',
    ISSUES_RESET_OWNER: 'issues/reset_owner'
}